import { widgetRegistry, getDefaultLayout } from '../../components/dashboard/widgetRegistry';

const STORAGE_KEY = 'settings.dashboardWidgets';

function loadLayout() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (e) {
    console.warn('Failed to load dashboard layout, using defaults', e);
  }
  return getDefaultLayout();
}

function saveLayout(layout) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(layout));
}

function passesRoleCheck(widget, rootGetters) {
  if (!widget.requiredGetters || widget.requiredGetters.length === 0) return true;
  return widget.requiredGetters.some((g) => rootGetters[`auth/token/${g}`]);
}

export const dashboard = {
  namespaced: true,
  state: () => ({
    layout: loadLayout(),
    libraryOpen: false,
  }),
  getters: {
    activeWidgets(state, getters, rootState, rootGetters) {
      return state.layout
        .filter((w) => w.enabled)
        .sort((a, b) => a.order - b.order)
        .map((w) => ({
          ...w,
          ...widgetRegistry[w.id],
        }))
        .filter((w) => w.component && w.released)
        .filter((w) => passesRoleCheck(w, rootGetters));
    },
    allWidgets(state, getters, rootState, rootGetters) {
      return Object.values(widgetRegistry)
        .filter((reg) => reg.released)
        .filter((reg) => passesRoleCheck(reg, rootGetters))
        .map((reg) => {
          const userConfig = state.layout.find((w) => w.id === reg.id);
          return {
            ...reg,
            enabled: userConfig ? userConfig.enabled : false,
            order: userConfig ? userConfig.order : 999,
            size: userConfig ? userConfig.size : reg.defaultSize,
          };
        });
    },
  },
  mutations: {
    setLayout(state, layout) {
      state.layout = layout;
      saveLayout(layout);
    },
    setLibraryOpen(state, open) {
      state.libraryOpen = open;
    },
    toggleWidget(state, widgetId) {
      const idx = state.layout.findIndex((w) => w.id === widgetId);
      if (idx >= 0) {
        state.layout[idx].enabled = !state.layout[idx].enabled;
      } else {
        state.layout.push({
          id: widgetId,
          enabled: true,
          order: state.layout.length,
          size: (widgetRegistry[widgetId] && widgetRegistry[widgetId].defaultSize) || 'sm',
        });
      }
      saveLayout(state.layout);
    },
    updateWidgetSize(state, { widgetId, size }) {
      const widget = state.layout.find((w) => w.id === widgetId);
      if (widget) {
        widget.size = size;
        saveLayout(state.layout);
      }
    },
    reorderWidgets(state, orderedIds) {
      orderedIds.forEach((id, index) => {
        const widget = state.layout.find((w) => w.id === id);
        if (widget) widget.order = index;
      });
      saveLayout(state.layout);
    },
    resetToDefaults(state) {
      state.layout = getDefaultLayout();
      saveLayout(state.layout);
    },
  },
};

export default dashboard;
